import { CatalogSectionSortCriterionEnum } from '../../../enums/catalogSectionSortCriterion.enum';
import { GetIsFreezeToManualParams } from './catalogView.types';

export const getIsFreezeToManual = ({
  configSnapshot,
  dirtyForAll,
  draft,
}: GetIsFreezeToManualParams): boolean =>
  dirtyForAll.includes('sortCriterion') &&
  draft.sortCriterion === CatalogSectionSortCriterionEnum.MANUAL &&
  configSnapshot.sortCriterion !== CatalogSectionSortCriterionEnum.MANUAL;
